// extracted by mini-css-extract-plugin
export default {"chargeRecord":"ChargeRecord_chargeRecord__5IbGs","chargeRecordTitle":"ChargeRecord_chargeRecordTitle__6UrFa"};